import { ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { BlueContainer, Paragraph } from '@app/shared/ui/atoms/Common';
import { WalletCard, type WalletCardProps } from '@app/shared/ui/molecules/Diamonds';

export const WalletSection = (props: WalletCardProps) => {
  const { t } = useTranslation();

  return (
    <section className="px-3">
      <BlueContainer withShadow className="space-y-4 p-[15px_13px_32px]">
        <Paragraph className="flex items-center">
          <ChevronRight />
          DOM {t('bank.wallet')}
        </Paragraph>
        <WalletCard {...props} />
      </BlueContainer>
    </section>
  );
};
